import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BreadcrumbService } from 'src/app/core/framework/breadcrumb.service';
import { IListaBundle } from 'src/app/core/list/lista-bundle.interface';
import { ListaUtil } from 'src/app/core/list/lista-util';
import { ILista } from 'src/app/core/list/lista.interface';
import { PoliticaDePrivacidadeService } from '../politica-de-privacidade.service';
import { PoliticaDePrivacidadeMetadata } from './politica-de-privacidade.metadata';

@Component({
  selector: 'app-politica-de-privacidade-lista',
  template: `<app-lista [controller]="this" [exibirLegenda]="false"
              [tipoLista]="'politica-de-privacidade'"></app-lista>`
})
export class PoliticaDePrivacidadeListaComponent implements OnInit, ILista {

  constructor(
    private breadcrumbService: BreadcrumbService
    , private router: Router
    , private politicaDePrivacidadeService: PoliticaDePrivacidadeService
  ) { }

  ngOnInit(): void {
    this.breadcrumbService.setItems([{label: 'Segurança'}, {label: 'Política de privacidade'}]);

    this.breadcrumbService.setMenuConfig(
      this.breadcrumbService.getOrCreateMenuConfig()
          .hideAll()
          .setShowVoltar(true)
          .setShowNovo(true, ['/seguranca/politica-de-privacidade-form/0'])
    );    
  }

  aoSelecionarLinha(e: IListaBundle, dataKey: any): void {
    const resultset = ListaUtil.getBundleResultset(e);
    this.router.navigate(['/seguranca/politica-de-privacidade-form', resultset.id]);
  }

  getService() {
    return this.politicaDePrivacidadeService;
  }

  getMetadata() {
    return PoliticaDePrivacidadeMetadata.getMetadata();
  }

}
